import React from 'react';
import { Colors } from '../../../../../constants/colors.constants';
import { useTranslation } from 'react-i18next';
import EmptyStateSystem from '../../../../DesignSystem/EmptyStateSystem';
import {
  ScheduleTimeIcon,
  CalendarQuestionIcon,
  ChevronLeftIcon
} from '../../../../../icons';
import {
  getHeightWeeklyPlan,
  getStringWithIcon
} from '../../../../../views/weeklyPlan/Commitments/wwp.helpers';
import PropTypes from 'prop-types';

export const EmptyWWPData = ({ type, buttonFn }) => {
  const { t } = useTranslation();
  const { DARK_GRAY } = Colors;

  const EMPTY_TYPES = {
    NO_WWP_EXISTS: {
      icon: <ScheduleTimeIcon color={DARK_GRAY} />,
      description: t('weekly_plan.empty_state.schedule_has_no_wwp')
    },
    NO_CURRENT_WWP: {
      icon: <CalendarQuestionIcon color={DARK_GRAY} />,
      description: getStringWithIcon({
        text: t('weekly_plan.empty_state.current_wwp_does_not_exist'),
        iconName: 'CHEVRON_LEFT_ICON',
        iconComponent: <ChevronLeftIcon />
      })
    }
  };

  if (!type || !EMPTY_TYPES[type]) {
    return null;
  }

  return (
    <div style={{ height: getHeightWeeklyPlan() }}>
      <EmptyStateSystem
        icon={EMPTY_TYPES[type].icon}
        sizeIcon="medium"
        descriptionMaxWidth="630px"
        description={EMPTY_TYPES[type].description}
        textButton={t('weekly_plan.empty_state.lookahead_button')}
        functionButton={buttonFn}
      />
    </div>
  );
};

EmptyWWPData.propTypes = {
  type: PropTypes.string.isRequired,
  buttonFn: PropTypes.func
};
